define([
  'js/aofl-js/0.8.0/app/app',
  'text!./index.css'
], function noMouseFocusModule(app, css) {
  'use strict';
  app.registerController('noMouseFocusController', [
    '$scope',
    '$element',
    'compileService',
    '$q',
    function noMouseFocusController($scope, $element, compileService) {
      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
      var usingMouse;

      var preFocus = function(event) {
        usingMouse = event.type === 'mousedown';
      };

      var addFocus = function(event) {
        if (usingMouse) {
          event.target.classList.add('focus--mouse');
          document.body.classList.add('focus--mouse');
        }
      };

      var removeFocus = function(event) {
        event.target.classList.remove('focus--mouse');
        document.body.classList.remove('focus--mouse');
      };

      $element.on('keydown', preFocus);
      $element.on('mousedown', preFocus);
      $element.on('focusin', addFocus);
      $element.on('focusout', removeFocus);
    }
  ]);

  app.registerDirective('noMouseFocus', function() {
    return {
      restrict: 'A',
      controller: 'noMouseFocusController'
    };
  });
});
